import styled from 'styled-components';

import Menu from 'components/shared/menu';
import { useProfile } from 'context/profile';
import { DenialListItem } from 'models/DenialListItem';
import { PERMISSIONS } from 'models/Profile';
import { colors } from 'styles/theme/colors';
import EditIcon from 'svg/EditIcon';
import ThreeDotMenu from 'svg/ThreeDotMenu';
import TrashIcon from 'svg/TrashIcon';

export type DenialListRowMenuProps = {
  denialListItem: DenialListItem;
  onEdit: (denialListItem: DenialListItem) => void;
  onDelete: (denialListItem: DenialListItem) => void;
};

export default function DenialListRowMenu({ denialListItem, onEdit, onDelete }: DenialListRowMenuProps) {
  const { profile } = useProfile();

  const canEdit = profile.has(PERMISSIONS.denialListItemEdit);
  const canDelete = profile.has(PERMISSIONS.denialListItemDelete);

  // View-only users get no actions menu at all.
  if (!canEdit && !canDelete) return null;

  return (
    <Menu $size='small'>
      <Menu.Trigger>
        <KebabButton type='button' aria-label='Row actions'>
          <ThreeDotMenu />
        </KebabButton>
      </Menu.Trigger>
      <Menu.Content position='right'>
        {canEdit && (
          <Menu.Item onClick={() => onEdit(denialListItem)}>
            <EditIcon width={14} height={14} />
            Edit Entry
          </Menu.Item>
        )}
        {canEdit && canDelete && <Menu.Divider />}
        {canDelete && (
          <DeleteItem onClick={() => onDelete(denialListItem)}>
            <TrashIcon width={14} height={14} color={colors.red100} />
            Delete Entry
          </DeleteItem>
        )}
      </Menu.Content>
    </Menu>
  );
}

const KebabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const DeleteItem = styled(Menu.Item)`
  color: ${({ theme }) => theme.colors.red100};
`;
